import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackClickedDownloadTranscriptButton.meta';

export type UseTrackClickedDownloadTranscriptButtonParams = {
  clip_id: string;
};

export const useTrackClickedDownloadTranscriptButton = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedDownloadTranscriptButton = useCallback(
    (params: UseTrackClickedDownloadTranscriptButtonParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClickedDownloadTranscriptButton };
};
